import Vue from 'vue'
import { Select, Tooltip } from 'ant-design-vue'
import { savePreviousData } from '@/services/api'
import { showNotification } from '@/services/calculate'

Vue.use(Select)
Vue.use(Tooltip)
export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-spin :spinning="loadingData">
        <a-icon slot="indicator" type="loading" class="loader-spin" spin/>
        <div v-if="params.colDef.cellRendererParams.dropdownName === 'contract'">
          <a-select
            :autoFocus="true"
            show-search
            :allowClear="Boolean(selectedOption)"
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important',
            }"
          >
            <a-select-option value="addContract" key="1">
              <a><i class="fa fa-plus" /> Add Contract </a>
            </a-select-option>
            <a-select-option v-for="options in dropDownList" :value="options.value" :key="options.id">
              <a-tooltip :title="$route.name==='project'? options.option : options.contract + ' - ' + options.contract_Name" placement="left">
                <span v-if="$route.name==='project'">{{ options.option }}</span>
                <span v-else>{{ options.contract }} - {{ options.contract_Name }}</span>
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="params.colDef.cellRendererParams.dropdownName === 'category'">
          <a-select
            :autoFocus="true"
            show-search
            :allowClear="Boolean(selectedOption)"
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option value="addCategory" key="1">
              <a><i class="fa fa-plus" /> Add Category Code </a>
            </a-select-option>
            <a-select-option v-for="options in dropDownList" :value="options.value" :key="options.id">
              <a-tooltip :title="$route.name==='project'? options.option : options.category_Code + ' - ' + options.description" placement="left">
              <span v-if="$route.name==='project'">{{ options.option }}</span>
              <span v-else>{{ options.category_Code }} - {{ options.description }}</span>
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="showDropdown && params.colDef.cellRendererParams.dropdownName === 'building'">
          <a-select
            :autoFocus="true"
            show-search size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            @dropdownVisibleChange="openDropdown"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option value="none" v-if="params.value">
              <a-tooltip title="None" placement="left">
                None
              </a-tooltip>
            </a-select-option>
            <a-select-option v-for="(options, index) in dropDownList" :value="params.colDef.cellRendererParams.showValue ? options.value : options.option" :key="$route.name==='project' ? index : options.id">
              <a-tooltip :title="options.option" placement="left">
                {{ options.option }}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="params.colDef.cellRendererParams.dropdownName === 'tenantType'">
          <a-select
            :autoFocus="true"
            show-search
            :allowClear="Boolean(selectedOption)"
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="options in dropDownList" :value="options.tenantType" :key="options.id">
              <a-tooltip :title="options.tenantType" placement="left">
              <span>{{ options.tenantType }}</span>
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="params.colDef.cellRendererParams.dropdownName === 'tenantBank'">
          <a-select
            :autoFocus="true"
            show-search
            :allowClear="Boolean(selectedOption)"
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="options in dropDownList" :value="options.tenantName" :key="options.id">
              <a-tooltip :title="options.tenantName" placement="left">
              <span>{{ options.tenantName }}</span>
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="showDropdown && params.colDef.cellRendererParams.dropdownName === 'conditionFactor'">
          <a-select
            :autoFocus="true"
            show-search
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="(options, index) in dropDownList" :value="options.value" :key="options.id">
              <a-tooltip :title="options.value" placement="left">
                {{ options.option ? options.option : 'None' }}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="showDropdown && params.colDef.cellRendererParams.dropdownName === 'constructionQualityFactor'">
          <a-select
            :autoFocus="true"
            show-search
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="(options, index) in dropDownList" :value="options.value" :key="options.id">
              <a-tooltip :title="options.value" placement="left">
                {{ options.option ? options.option : 'None' }}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="params.colDef.cellRendererParams.dropdownName === 'costType'">
          <a-select
            :autoFocus="true"
            show-search
            :allowClear="Boolean(selectedOption)"
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="options in dropDownList" :value="options.costType" :key="options.id">
              <a-tooltip :title="options.costType" placement="left">
              <span>{{ options.costType }}</span>
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="params.colDef.cellRendererParams.dropdownName === 'tile'">
          <a-select
            :allowClear="Boolean(selectedOption)"
            :autoFocus="true"
            show-search
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="options in dropDownList" :value="options.id" :key="options.id">
              <a-tooltip :title="options.tileName" placement="left">
              <span>{{ options.tileName }}</span>
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="showDropdown && params.colDef.cellRendererParams.dropdownName === 'unit'">
          <a-select
            :autoFocus="true"
            show-search
            :allowClear="Boolean(selectedOption)"
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="(options, index) in dropDownList" :value="options.value" :key="options.id">
              <a-tooltip :title="options.value" placement="left">
                {{ options.option ? options.option : 'None' }}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div v-else-if="showDropdown && params.colDef.cellRendererParams.dropdownName !== 'building'">
          <a-select
            :autoFocus="true"
            show-search
            size="small"
            placeholder="Select"
            v-model="selectedOption"
            style="width: 100%;"
            @change="handleChange"
            :dropdownStyle="{
              minWidth: width,
              overflow: 'auto !important'
            }"
          >
            <a-select-option v-for="(options, index) in dropDownList" :value="params.colDef.cellRendererParams.showValue ? options.value : options.option" :key="$route.name==='project' ? index : options.id">
              <a-tooltip :title="options.option" placement="left">
                {{ options.option ? options.option : 'None' }}
              </a-tooltip>
            </a-select-option>
          </a-select>
        </div>
      </a-spin>
    </div>
    `,
  data() {
    return {
      loadingData: false,
      dropDownList: [],
      selectedOption: null,
      savePreviousData: savePreviousData,
      showDropdown: true,
      isChange: false,
      width: 'auto !important',
    }
  },
  beforeMount() {
    const list = this.params.colDef.cellRendererParams.dropdownData
    this.showDropdown = true
    switch (this.params.colDef.cellRendererParams.dropdownName) {
      case 'building':
        this.loadingData = true
        this.dropDownList = this.params.colDef.cellRendererParams.templates.filter(
          i =>
            i.analysis_Type_Id === this.params.data.analysis_Type_Id &&
            i.structure_Profile_Id === this.params.data.structure_Profile_Id &&
            i.building_Use === this.params.data.building_Use,
        )
        this.dropDownList = this.dropDownList.map(data => {
          data.option = data.template_Name
          return data
        })
        this.loadingData = false
        break
      case 'contract':
        this.showDropdown = false
        list.contract.forEach(element => {
          if (this.$route.name === 'project') {
            element.contract = element.option.split('-')[0]
          }
          element.value =
            this.$route.name === 'project'
              ? element.value
              : `${element.contract} - ${element.contract_Name}`
          this.dropDownList.push(element)
        })
        break
      case 'category':
        this.showDropdown = false
        list.category.forEach(element => {
          if (this.$route.name === 'project') {
            element.category_Code = element.option.split('-')[0]
          }
          element.value =
            this.$route.name === 'project'
              ? element.value
              : `${element.category_Code} - ${element.description}`
          this.dropDownList.push(element)
        })
        break
      case 'tenantBank':
        if (this.params.data.tenantTypeId) {
          this.dropDownList = list[
            this.params.colDef.cellRendererParams.dropdownName
          ].filter(i => i.tenantTypeId === this.params.data.tenantTypeId)
        } else {
          this.dropDownList =
            list[this.params.colDef.cellRendererParams.dropdownName]
        }
        break
      case 'conditionFactor':
        list.forEach(element => {
          element.conditionFactor = element.value
          element.conditionFactorId = element.id
          this.dropDownList.push(element)
        })
        break
      case 'constructionQualityFactor':
        list.forEach(element => {
          element.constructionQualityFactor = element.value
          element.constructionQualityFactorId = element.id
          this.dropDownList.push(element)
        })
        break
      case 'costType':
        this.dropDownList = list.costType.filter(i => i.id !== 8)
        break

      default:
        if (
          this.params.colDef.cellRendererParams.dropdownName ===
            'temp_building_use' &&
          this.params.colDef.cellRendererParams.type === 'projectDetails'
        ) {
          this.dropDownList = list.temp_building_use.filter(
            i => i.structureProfileId === this.params.data.structure_Profile_Id,
          )
        } else {
          this.dropDownList =
            list[this.params.colDef.cellRendererParams.dropdownName]
        }
        break
    }
    if (this.params.colDef.cellRendererParams.width) {
      this.width = this.params.colDef.cellRendererParams.width
    }
  },
  created() {
    this.isChange = false
    const list = this.params.colDef.cellRendererParams.dropdownData
    switch (this.params.colDef.cellRendererParams.dropdownName) {
      case 'contract':
        const contractList = list.contract
        if (this.params.value || this.params.value === 0) {
          if (this.$route.name === 'project') {
            const contract = contractList.find(i => i.id === this.params.data.mContractId)
            if (contract) {
              this.selectedOption = contract.value
            } else {
              this.selectedOption = this.params.value
            }
          } else if (this.$route.name === 'templatesid') {
            this.selectedOption = `${this.params.value} - ${
              contractList.find(i => i.contract === this.params.value)
                .contract_Name
            }`
          } else {
            this.selectedOption = `${this.params.value} - ${
              contractList.find(i => i.contract === this.params.value)
                .contract_Name
            }`
          }
        }
        break
      case 'category':
        const categoryList = list.category
        if (this.params.value || this.params.value === 0) {
          if (this.$route.name === 'project') {
            const categoryCode = categoryList.find(i => i.id === this.params.data.mCategoryCodeId)
            if (categoryCode) {
              this.selectedOption = categoryCode.value
            } else {
              this.selectedOption = this.params.value
            }
          } else {
            this.selectedOption = `${this.params.value} - ${
              categoryList.find(
                i => Number(i.category_Code) === this.params.value,
              ).description
            }`
          }
        }
        break
      case 'conditionFactor':
        if (this.params.value) {
          this.selectedOption =
            this.params.value === 0 ? undefined : this.params.value
        }
        break
      case 'constructionQualityFactor':
        if (this.params.value) {
          this.selectedOption =
            this.params.value === 0 ? undefined : this.params.value
        }
        break

      default:
        this.selectedOption =
          this.params.value === 0 ? undefined : this.params.value
        break
    }
  },
  methods: {
    handleChange(value, key) {
      if (this.params.colDef.cellRendererParams.type === 'projectDetails') {
        if (this.params.value) {
          var that = this
          this.$confirm({
            title: `Are you sure want to change ${this.params.colDef[
              'headerName'
            ].toLowerCase()}?`,
            content: h => (
              <div style="color:red">
                <p>
                  This action will change all information related this asset.
                </p>
                <p>Please confirm.</p>
              </div>
            ),
            onOk() {
              that.selectedOption = value === 'none' ? undefined : value
              that.$root.$emit(
                'updateAssetsDetails',
                value === 'none' ? 0 : value,
                that.params.data,
                that.params.colDef.field,
                that.params.rowIndex,
                value ? key['key'] : null,
              )
            },
            onCancel() {
              that.selectedOption = that.params.value
            },
          })
        } else {
          this.$root.$emit(
            'updateAssetsDetails',
            value,
            this.params.data,
            this.params.colDef.field,
            this.params.rowIndex,
            key['key'],
          )
        }
      } else {
        switch (this.params.colDef.cellRendererParams.type) {
          case 'tenants':
            this.$root.$emit(
              'saveTenantData',
              this.params.colDef.field,
              value,
              this.params.colDef.headerName,
              this.params.data,
            )
            break
          case 'projectTenants':
            this.$root.$emit(
              `saveTenantData${this.params.data.assetId}`,
              this.params.colDef.field,
              value,
              this.params.colDef.headerName,
              this.params.data,
            )
            break
          case 'tenantBank':
            const tenantBank = this.dropDownList.find(i => i.tenantName === value)
            this.$root.$emit(
              'copyTenantBank',
              value || 'none',
              tenantBank ? tenantBank.id : null,
              this.params.data,
              this.params.rowIndex,
            )
            break
          case 'projectTenantBank':
            const projectTenantBank = this.dropDownList.find(i => i.tenantName === value)
            this.$root.$emit(
              `copyTenantBank${this.params.data.assetId}`,
              value || 'none',
              projectTenantBank ? projectTenantBank.id : null,
              this.params.data,
              this.params.rowIndex,
            )
            break
          case 'tenantType':
            this.$root.$emit(
              'saveTenantData',
              this.params.colDef.field,
              value || 'none',
              this.params.colDef.headerName,
              this.params.data,
            )
            break
          case 'projectTenantType':
            this.$root.$emit(
              `saveTenantData${this.params.data.assetId}`,
              this.params.colDef.field,
              value || 'none',
              this.params.colDef.headerName,
              this.params.data,
            )
            break
          case 'analysisSheet':
            switch (value) {
              case 'addContract':
              case 'addCategory':
                this.selectedOption = window.previousValue
                this.$root.$emit(
                  'saveAnalysisData',
                  value,
                  this.params.data,
                  this.params.colDef.field,
                  this.params.rowIndex,
                )
                break
              default:
                switch (this.params.colDef.cellRendererParams.dropdownName) {
                  case 'contract':
                    this.isChange = true
                    const contract = this.dropDownList.find(
                      i => i.value === value,
                    )
                    this.selectedOption = contract ? contract.contract : undefined
                    this.$root.$emit(
                      'saveAnalysisData',
                      contract ? contract.contract : 'none',
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      contract,
                    )
                    break
                  case 'category':
                    this.isChange = true
                    const category = this.dropDownList.find(
                      i => i.value === value,
                    )
                    this.selectedOption = category ? category.category_Code : undefined
                    this.$root.$emit(
                      'saveAnalysisData',
                      category ? category.category_Code : 'none',
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      category,
                    )
                    break
                  case 'unit':
                    const unit = this.dropDownList.find(i => i.option === value)
                    this.$root.$emit(
                      'saveAnalysisData',
                      value || 'none',
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      unit,
                    )
                    break

                  default:
                    const data = this.dropDownList.find(i => i.option === value)
                    this.$root.$emit(
                      'saveAnalysisData',
                      value,
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      data,
                    )
                    break
                }
                break
            }
            break
          case 'projectDetails':
            this.$root.$emit(
              'updateAssetsDetails',
              value,
              this.params.data,
              this.params.colDef.field,
              this.params.rowIndex,
            )
            break
          default:
            switch (value) {
              case 'addContract':
              case 'addCategory':
                this.selectedOption = window.previousValue
                this.$root.$emit(
                  this.params.colDef.cellRendererParams.type ===
                        'actualCostLevel'
                    ? 'handleTileChange'
                    : this.params.colDef.cellRendererParams.type ===
                          'estimateGroup'
                      ? `onUpdateTakeoff${this.params.data.assetId}`
                      : this.params.colDef.cellRendererParams.type ===
                          'estimateTakeoff'
                        ? 'onUpdateTakeoffs'
                        : 'handleChange',
                  value,
                  this.params.data,
                  this.params.colDef.field,
                  this.params.rowIndex,
                )
                break
              default:
                switch (this.params.colDef.cellRendererParams.dropdownName) {
                  case 'contract':
                    this.isChange = true
                    const contract = this.dropDownList.find(
                      i => i.value === value,
                    )
                    this.selectedOption = contract ? contract.contract : undefined
                    this.$root.$emit(
                      this.params.colDef.cellRendererParams.type ===
                        'actualCostLevel'
                        ? 'handleTileChange'
                        : this.params.colDef.cellRendererParams.type ===
                          'estimateGroup'
                          ? `onUpdateTakeoff${this.params.data.assetId}`
                          : this.params.colDef.cellRendererParams.type ===
                          'estimateTakeoff'
                            ? 'onUpdateTakeoffs'
                            : 'handleChange',
                      contract ? contract.contract : 'none',
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      contract,
                    )
                    break
                  case 'category':
                    this.isChange = true
                    const category = this.dropDownList.find(
                      i => i.value === value,
                    )
                    this.selectedOption = category ? category.category_Code : undefined
                    this.$root.$emit(
                      this.params.colDef.cellRendererParams.type ===
                        'actualCostLevel'
                        ? 'handleTileChange'
                        : this.params.colDef.cellRendererParams.type ===
                          'estimateGroup'
                          ? `onUpdateTakeoff${this.params.data.assetId}`
                          : this.params.colDef.cellRendererParams.type ===
                          'estimateTakeoff'
                            ? 'onUpdateTakeoffs'
                            : 'handleChange',
                      category ? category.category_Code : 'none',
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      category,
                    )
                    break
                  case 'unit':
                    const unit = this.dropDownList.find(
                      i => i.option === value,
                    )
                    this.$root.$emit(
                      this.params.colDef.cellRendererParams.type ===
                        'actualCostLevel'
                        ? 'handleTileChange'
                        : this.params.colDef.cellRendererParams.type ===
                          'estimateGroup'
                          ? `onUpdateTakeoff${this.params.data.assetId}`
                          : this.params.colDef.cellRendererParams.type ===
                          'estimateTakeoff'
                            ? 'onUpdateTakeoffs'
                            : 'handleChange',
                      value || 'none',
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      unit,
                    )
                    break
                  case 'costType':
                    this.isChange = true
                    const costType = this.dropDownList.find(
                      i => i.costType === value,
                    )
                    this.selectedOption = costType ? costType.costType : undefined
                    this.$root.$emit(
                      this.params.colDef.cellRendererParams.type ===
                        'actualCostLevel'
                        ? 'handleTileChange'
                        : 'handleChange',
                      costType ? costType.costType : 'none',
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      costType,
                    )
                    break
                  case 'tile':
                    this.isChange = true
                    const tile = this.dropDownList.find(i => i.id === value)
                    this.selectedOption = tile ? tile.tileName : undefined
                    this.$root.$emit(
                      this.params.colDef.cellRendererParams.type ===
                        'actualCostLevel'
                        ? 'handleTileChange'
                        : 'handleChange',
                      tile ? tile.id : null,
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      tile,
                    )
                    break
                  case 'constructionQualityFactor':
                    this.isChange = true
                    const factor = this.dropDownList.find(
                      i => i.value === value,
                    )
                    this.selectedOption = factor.value
                    this.$root.$emit(
                      this.params.colDef.cellRendererParams.type ===
                        'actualCostLevel'
                        ? 'handleTileChange'
                        : this.params.colDef.cellRendererParams.type ===
                          'estimateGroup'
                          ? `onUpdateTakeoff${this.params.data.assetId}`
                          : this.params.colDef.cellRendererParams.type ===
                          'estimateTakeoff'
                            ? 'onUpdateTakeoffs'
                            : 'handleChange',
                      value,
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                      undefined,
                      factor,
                    )
                    break

                  default:
                    this.$root.$emit(
                      'handleChange',
                      value,
                      this.params.data,
                      this.params.colDef.field,
                      this.params.rowIndex,
                    )
                    break
                }
                break
            }
            break
        }
      }
    },
    getValue() {
      if (
        !this.isChange &&
        this.params.colDef.cellRendererParams.dropdownName === 'contract'
      ) {
        const contract = this.dropDownList.find(
          i => i.value === this.selectedOption,
        )
        if (contract) {
          this.selectedOption = contract.contract
            ? contract.contract
            : contract.option
        }
        return this.selectedOption
      } else if (
        !this.isChange &&
        this.params.colDef.cellRendererParams.dropdownName === 'category'
      ) {
        const category = this.dropDownList.find(
          i => i.value === this.selectedOption,
        )
        if (category) {
          this.selectedOption = category.category_Code
            ? category.category_Code
            : category.categoryCode
        }
        return this.selectedOption
      }
      return this.selectedOption
    },
    openDropdown(open) {
      if (open && this.dropDownList.length === 0) {
        showNotification(
          'info',
          'Building',
          'There are no templates published yet. Please publish the template to see the list.',
        )
      }
    },
  },
})
